<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword" :showNav="true"></Header>

    <div class="seckill">
      <div class="seckill_list">
        <div class="container flex">
          <li
            class="active flex center"
            v-for="(item) in seckillTime"
            :key="item.timeshow"
            v-if="i=item.now==1"
          >
            <div class="title">{{item.timeshow}}</div>
            <div class="shengyu">
              <span>正在秒杀</span>
              <br />
              <span>距结束 {{count_time[0]}}:{{count_time[1]}}:{{count_time[2]}}</span>
            </div>
          </li>
          <li
            class="center"
            v-for="(item) in seckillTime"
            :key="item.timeshow"
            v-if="i=item.now==0"
          >
            <div class="title">{{item.timeshow}}</div>
            <el-button round>即将开始</el-button>
          </li>
        </div>
      </div>
      <div class="jifenSC container">
        <div class="jifenList flex">
          <a
            :href="'#/goodsdetail?id='+item.id"
            class="jifenItem"
            v-for="(item) in seckillgoods"
            :key="item.id"
          >
            <div class="img center">
              <img :src="item.indexpic" alt srcset class="goodsimg" />
            </div>
            <div class="goodsInfo">
              <div class="name ellipsis">{{item.title}}</div>
              <div class="duihuan flex ju-be">
                <div class="num">
                  <div>
                    <span class>￥{{item.price}}</span>
                    <span class="yuanjia">￥{{item.price1}}</span>
                  </div>
                  <div class="yisou flex">
                    <span>已售{{parseInt(item.sold/(item.stock+item.sold)*100)}}%</span>
                    <el-progress :percentage="70" class="progress" :show-text="showText"></el-progress>
                  </div>
                </div>
                <button class type="primary">立即抢购</button>
              </div>
            </div>
          </a>
        </div>
        <el-pagination background layout="prev, pager, next" :total="seckillgoods.length" class="fenye"></el-pagination>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>
<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "index",
  data() {
    return {
      showText: false,
      count_time:[],
      userInfo: {
        headimgurl: "",
        username: ""
      },
      keyword: "",
      seckillgoods: [],
      seckillTime: [],
      indexData: {
        index_cartnum: 0,
        index_shop_self: {
          adlist: [{ url: "", src: "" }, { url: "", src: "" }]
        }
      }
    };
  },
  methods: {
    someconfig() {},
    // 获取秒杀的商品
    async getseckillgoods() {
      this.seckillgoods = await this.$fetch("index/groups", { body: 16 });
      console.log("this.seckillgoods", this.seckillgoods);
    },
    // 获取秒杀时间列表
    async getseckillTime() {
      let that=this;
      this.seckillTime = await this.$fetch("index/grouprange");
      console.log("this.seckillTime", this.seckillTime);
      if (this.seckillTime[0].now == 1) {
        let item=this.seckillTime[0];
        let countTime = item.timeto - item.timefrom;
          let timeId = setInterval(function() {
          that.count_time = getDate(countTime);
          console.log(that.count_time);
          countTime--;
          if (countTime <= 0) {
            clearInterval(timeId);
          }
        }, 1000);
      }
    }
  },
  async mounted() {
    this.indexData = await this.$fetch("Index/indexdata");
    this.getseckillTime();
    this.getseckillgoods();
    this.guid = sessionStorage.guid;
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
  }
};
</script>


<style lang='scss' scoped>
.jifenList {
  .jifenItem {
    width: 290px;
    margin-right: 10px;
    .img {
      height: 290px;
      background: #fff;
      .goodsimg {
        width: 200px;
        height: 200px;
      }
    }
    .goodsInfo {
      height: 100px;
      border-top: 1px solid #f0f0f0;
      background: #fff;
      .yisou {
        font-size: 12px;
        color: #666666;
        .progress {
          width: 100px;
          margin-left: 5px;
        }
      }
    }
  }
}
.center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/seckill.vue